<script lang="ts" setup>
import type { OtTabType } from '@1trading/design-system';
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import futuresFeatureFlagService from '@exchange/libs/futures/service/src/lib/futures-feature-flag.service';
import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

type FilterTab = OtTabType<string>;

const props = defineProps({
  activeMarketTypeFilter: { type: String, required: true },
  variant: { type: String as PropType<'dark-medium' | 'default'>, required: true },
});

const emit = defineEmits<(e: 'market-type-filter-selected', v: string) => void>();

const { t } = useI18n({ useScope: 'global' });

const { isEnabled: isFuturesEnabled } = futuresFeatureFlagService;

const isActive = (tabId: string): boolean => props.activeMarketTypeFilter === tabId;

const tabs = computed(() => [
  {
    getTitle: () => '',
    id: CONSTANTS.CURRENCY_FILTER_FAVORITES,
    icon: 'bookmark',
    active: isActive(CONSTANTS.CURRENCY_FILTER_FAVORITES),
  },
  {
    getTitle: () => t('fundamentals.currencies.all'),
    id: CONSTANTS.CURRENCY_FILTER_ALL,
    active: isActive(CONSTANTS.CURRENCY_FILTER_ALL),
  },
  {
    getTitle: () => 'Spot',
    id: MarketType.SPOT,
    active: isActive(MarketType.SPOT),
  },
  ...(isFuturesEnabled.value
    ? [
        {
          getTitle: () => 'Perp',
          id: MarketType.PERP,
          active: isActive(MarketType.PERP),
        },
      ]
    : []),
]);

const onTabSelected = (tab: FilterTab): void => {
  emit('market-type-filter-selected', tab.id);
};
</script>

<template>
  <div
    class="market-list-filters"
    :class="[`market-list-filters--${variant}`]"
  >
    <ot-tabs
      :tabs="tabs"
      :dense="false"
      :scrollable="true"
      @tab-selected="onTabSelected"
    />
  </div>
</template>
